// How I Work — content for all 6 steps.
// Optional: body = intro paragraphs, bulletsLabel + bullets = single list, or sections = array of { label, bullets }.

export const HOW_I_WORK_STEPS = [
  {
    id: 1,
    title: 'Strategic alignment',
    tagline: 'From leadership vision to clear product direction',
    body: [
      'Initiatives start from OKRs and leadership\'s read on the market: sales events, partnerships, competitive moves. I turn that into concrete product direction and align early with PM and Eng.',
    ],
    bulletsLabel: 'How I work:',
    bullets: [
      'AI agents run competitive research and gap analysis in minutes',
      'I validate the outputs and decide what\'s worth acting on',
      'Example: a C-suite competitor brief became a Confluence-ready table in minutes (~80% accurate after review), instead of days of manual research',
    ],
    takeaway: 'Strategy comes from leadership. My job is to compress time-to-clarity without skipping judgment.',
  },
  {
    id: 2,
    title: 'Defining the opportunity',
    tagline: 'Real signals from support, sales, and the product ecosystem',
    body: [
      'I define the opportunity from live signals: support tickets, sales win/loss feedback, and cross-team dependencies.',
    ],
    bulletsLabel: 'How I work:',
    bullets: [
      'I define the problem, audience, and success metrics before anything is built',
      'AI speeds up journey mapping, gap analysis, and sizing; I prioritize',
      'Example: from support launch docs, an agent drafted the pain points in minutes, I refined them, and the result was launch-ready',
    ],
    takeaway: 'Ground decisions in operational reality, not slide-deck discovery.',
  },
  {
    id: 3,
    title: 'Rapid prototyping',
    tagline: 'Working prototypes, not mockups for sign-off',
    body: [
      'I build end-to-end CX workflows people can actually use. The prototype is what we align around.',
    ],
    bulletsLabel: 'How I work:',
    bullets: [
      'Example: Agentic CX, with analytics for managers and conversational builders for admins (not a ChatGPT clone)',
      'Stack: Cursor, Figma, Claude Code, Codex. I decide, agents execute',
      'Outputs: PRD, functional spec, and a GTM starter for Sales and Eng',
    ],
    takeaway: 'Replace debate with something teams can react to.',
  },
  {
    id: 4,
    title: 'Customer validation',
    tagline: 'Testing with the teams who use the product daily',
    body: [
      'Before any backend investment, we pressure-test concepts on the prototype with the people who use the product every day.',
    ],
    bulletsLabel: 'How I work:',
    bullets: [
      'Validate with Support, Sales, and Accounts, not generic VoC',
      'Test UX, sellability, and supportability',
      'Iterate quickly on what we learn, with AI-assisted workflows',
    ],
    takeaway: 'If Sales can\'t sell it or Support can\'t support it, it\'s not ready.',
  },
  {
    id: 5,
    title: 'Iteration and strategic alignment',
    tagline: 'Making the tradeoffs and locking direction',
    body: [
      'I turn what validation showed into a clear recommendation for leadership. The prototype and docs already exist, so the conversation stays on tradeoffs.',
    ],
    bulletsLabel: 'How I work:',
    bullets: [
      'Weigh customer value, backend effort, business priority, and timeline',
      'Commit, narrow, or defer, explicitly',
    ],
    takeaway: 'Alignment is about decisions, not re-litigating what to build.',
  },
  {
    id: 6,
    title: 'Production to impact',
    tagline: 'Integrate the backend, ship, measure, improve',
    body: [
      'Eng receives a working prototype, a written PRD, and a ready spec, so the main work is connecting the backend, not guessing at intent.',
    ],
    bulletsLabel: 'How I work:',
    bullets: [
      'Figma MCP to codebase: designers code components, Eng validates PRs',
      'I stay embedded through the build to protect fidelity, constraints, and scope',
      'Result: new app at $150k MRR; support feedback drives ongoing improvements',
    ],
    takeaway: 'The prototype-to-production gap is narrow by design.',
  },
];
